import React, { useContext, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const EndingDialogContext = React.createContext();
const EndingDialogProvider = props => {
  const [endingDialogData, setEndingDialogData] = useState({
    show: false,
    message: '',
    title: '',
    withRedirect: false,
    url: ''
  });
  return (
    <EndingDialogContext.Provider
      value={{ endingDialogData, setEndingDialogData }}
    >
      {props.children}
    </EndingDialogContext.Provider>
  );
};

const EndingDialog = () => {
  const { endingDialogData } = useContext(EndingDialogContext);
  const { title, message, show, withRedirect, url } = endingDialogData;
  return (
    <Dialog
      open={show}
      // onClose={() => window.close()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          style={{ whiteSpace: 'pre-wrap' }}
        >
          {message}
        </DialogContentText>
      </DialogContent>
      {withRedirect && (
        <DialogActions>
          <Button
            onClick={() => {
              window.location.href = url;
            }}
            color="primary"
            variant="outlined"
            autoFocus
          >
            Finalizar
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default EndingDialog;
export { EndingDialogContext, EndingDialogProvider };
